import { Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField, Tooltip } from '@mui/material';
import { buttonLabels, DialogHeaders, emptyLabels, GridStatusLabelVariant, ToasterTexts } from '../shared/constants';
import { CancelIcon, GridSearchIcon } from '../../icon';
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { Contact } from '../../models/conversations';
import { useEffect, useState } from 'react';
import { ColDef, GridApi, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import GridComponent from '../shared/grid';
import ButtonComponent from '../shared/button/button.component';
import { FaceAuthenticationModel, FaceRegistrationInviteLinkStatus } from '../../models/secure-file';
import { UtilityService } from '../../services/UtilityService';
import { MessageService } from '../../services/MessageService';
import { SecureFileService } from '../../services/SecureFileService';
import { UserService } from '../../services/UserService';
import { PlanMetrics } from '../../models/plan-metrics.model';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { v4 as uuid } from "uuid";
import { HmacSignatureUtilities } from '../../services/hmac-encryption-decryption';


interface Props {
    OnClose: () => void;
    Show: boolean;
}

const SendInviteComponent = (props: Props) => {
    const Contacts: Contact[] = useSelector(selector.contacts);
    const FaceAuthenticationFiles: FaceAuthenticationModel[] = useSelector(selector.faceAuthenticatonFiles);
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics);
    const IsNewOrgFlow: boolean = useSelector(selector.isNewOrgFlow);


    const [IsLoading, setIsLoading] = useState<boolean>(false);
    const [gridApi, setGridApi] = useState<GridApi>(null);
    const [selectedContacts, setSelectedContacts] = useState<Contact[]>([])
    const [rowData, setRowData] = useState<Contact[]>([])

    const ContactColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Name",
            headerCheckboxSelection: true,
            checkboxSelection: true,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "IsUnsubscribed",
            headerName: "Status",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.IsUnsubscribed ? "Unsubscribed" : params.data.IsBlocked ? "Blocked" : "Active"
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = params.data.IsUnsubscribed ? "Unsubscribed" : params.data.IsBlocked ? "Blocked" : "Active";
                    const variant = params.data.IsUnsubscribed ? GridStatusLabelVariant.Warning : params.data.IsBlocked ? GridStatusLabelVariant.Danger : GridStatusLabelVariant.Active;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
                return undefined
            },
        },
        {
            field: "MaskedPhoneNumber",
            headerName: "Phone Number",
            wrapText: true,
            autoHeight: true,
            valueFormatter: (params) => {
                return params.data.MaskedPhoneNumber
            },
            valueGetter: (params: ValueGetterParams) => {
                const raw =
                    params.data?.PhoneNumber ||
                    params.data?.MaskedPhoneNumber ||
                    "";
                return `${raw} ${UtilityService.maskPhoneNumberOnLength(raw)} ${raw.replace(/\D/g, "")}`;
            },
        },
    ]

    const searchContacts = (e: any) => {
        gridApi.setQuickFilter(e.target.value)
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
    }

    const onSelectionChanged = () => {
        let SelectedContacts: Contact[] = gridApi.getSelectedRows()
        if (gridApi && SelectedContacts.length >= 0) {
            setSelectedContacts(SelectedContacts)
        }
    }

    useEffect(() => {
        let invetedContacts = FaceAuthenticationFiles?.filter(x => x.Status !== FaceRegistrationInviteLinkStatus.Expired)
        let data = Contacts?.filter(x => !invetedContacts?.some(y => UtilityService.unmaskPhoneNumber(y.ContactPhoneNumber) === UtilityService.unmaskPhoneNumber(x.MaskedPhoneNumber)))?.filter(x => !x.IsUnsubscribed)
        setRowData(data?.filter(x => x?.IsOptInCollected))
    }, [Contacts])


    const sendInvite = () => {
        if (!IsNewOrgFlow && PlanMetrics.NormalTextingUsage.PlanCredits >= 0 && PlanMetrics.NormalTextingUsage.GetRemainingCredits() < selectedContacts?.length) {
            setToast(ToasterTexts.CREDITS_PER_MONTH_ERROR_MESSAGE.replace('<CREDITS>', PlanMetrics.NormalTextingUsage.TotalCredits.toString()), ToasterType.DANGER);
            return;
        }
        setIsLoading(true)
        let user = UserService.getCurrentUserFromLocalStorage();
        let data = {
            phoneNumbers: selectedContacts.map(x => UtilityService.unmaskPhoneNumber(x.MaskedPhoneNumber)),
            falkon_user: UtilityService.unmaskPhoneNumber(user?.PhoneNumber),
            falkon_user_name: user?.FullName
        }

        SecureFileService.massActionSendInvite(user?.OrgId, data).then((res) => {
            if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                var formData = new FormData();
                res.data.forEach((item, index) => {
                    formData.append(`request[${index}].ToPhoneNumber`, item.phoneNumber)
                    formData.append(`request[${index}].Body`, `Face Registration Link: ${item.link}`);
                    formData.append(`request[${index}].File`, null);
                    formData.append(`request[${index}].Credits`, "1")
                    formData.append(`request[${index}].SequenceId`, uuid())
                });
                MessageService.sendGroupIndividualCardsMessage(formData).then((res) => {

                }).catch((err) => {

                })
            }
            else {
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
            }
            setSelectedContacts([])
            setIsLoading(false)
            props.OnClose()
        }).catch((err) => {
            setSelectedContacts([])
            setIsLoading(false)
            props.OnClose()
        })
    }

    return (
        <>
            <Dialog
                // onClose={() => { props.OnClose() }}
                aria-labelledby="responsive-dialog-title"
                open={props.Show}
                BackdropProps={{
                    style: { backgroundColor: "transparent" },
                }}
                className={"h-p-100"}
                disableEscapeKeyDown
                PaperProps={{
                    classes: {
                        root: "box-shadow-primary-header-shadow",
                    },
                    style: {
                        height: "70%",
                        width: "100vh",
                    },
                }}
            >
                <DialogTitle className="p-2">
                    <div className={`h3-semibold color-display-title d-flex`} >
                        {DialogHeaders.INVITE}
                        <Tooltip title="Close" placement="bottom">
                            <span className="ml-auto">
                                <CancelIcon onClick={() => props.OnClose()} className="c-pointer" />
                            </span>
                        </Tooltip>
                    </div>
                </DialogTitle>
                <DialogContent className='px-2'>
                    <TextField
                        fullWidth
                        placeholder={"Find a contact..."}
                        onChange={searchContacts}
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <GridSearchIcon />
                                </InputAdornment>
                            ),
                            classes: {
                                input: "h6-regular color-text-field-font",
                                notchedOutline: "br-4",
                            },
                        }}
                        size="small"
                        className="h-p-10"
                    />
                    <div className='h-p-90'>
                        <GridComponent
                            ColumnDefs={ContactColoumnDefs}
                            RowData={rowData}
                            OnGridReady={onGridReady}
                            OnSelectionChanged={onSelectionChanged}
                            IsPaginationEnabled={false}
                            EmptyLabel={emptyLabels.CONTACTS}
                            LockVisible={true}
                        />
                    </div>
                </DialogContent>
                <DialogActions className="px-3">
                    <ButtonComponent OnClick={() => { props.OnClose(); setSelectedContacts([]) }} ButtonLabel={buttonLabels.CANCEL} Variant={"secondary-btn-small"} ClassName={` ml-auto  `} />
                    <ButtonComponent OnClick={() => { sendInvite() }} Loading={IsLoading} ButtonLabel={buttonLabels.SEND_INVITE} Variant={!!selectedContacts?.length ? "primary-btn-small" : "disabled-btn-small"} />
                </DialogActions>
            </Dialog>
        </>
    )
}
export default SendInviteComponent